//手机号
export const phoneReg = /^1[3456789]\d{9}$/;
//身份证
export const sfzReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
//邮箱
export const emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
//整数
export const intReg = /^[-+]?\d*$/
//只含字母的字符串
export const letterReg = /^[a-zA-Z]+$/
export const checkStrLength = (n) => {
    return new RegExp(`^.{${n}}$`)
}
//姓名
export const nameReg = /^[\u4E00-\u9FA5]{1,5}$/;
//中文
export const chineseReg = /[^\u4E00-\u9FA5]/g;
//身份证
export const idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;